// extracted by mini-css-extract-plugin
export default {"container":"topic-page_container__26rqP","filters":"topic-page_filters__3CjTw"};